<template>
  <div class="carEdit full-height linear-main3">
    <ld-header
      :transparent="true"
      :white="true"
    >
      {{ $t('A126','订单填写') }}
    </ld-header>
    <div class="carEditwrapper">
      <mescroll-vue
        ref="mescroll"
        :down="down"
      >
        <div class="box">
          <van-card :thumb="info.coverUrl">
            <div slot="title">
              <span class="font14 font-lg">{{ info.vehicleTypeName }}</span>
              <span class="white bg-main type">{{ carSearchInfo.useType | type }}</span>
              <span
                class="fr main-color"
                @click="isShow = !isShow"
              >{{ $t('J210','服务说明') }}
                <van-icon
                  class="info"
                  name="info"
                />
              </span>
            </div>
            <div
              slot="desc"
              class="pad-tb-5 gray"
            >
              {{ info.vehicleTypeDesc }}
            </div>
            <div
              slot="tags"
            >
              <van-icon class="iconfont iconchangyongicon-" />×{{ info.luggageNum }}
              <van-icon class="iconfont icongerentouxiang_o" />×{{ info.personNum }}
              &nbsp;
              <span
                class="main-color"
                @click="baggageExplainShow = true"
              >
                {{ $t('J244', '行李说明') }}
                <van-icon
                  name="arrow"
                  class="vertical-middle"
                />
              </span>
            </div>
            <div
              slot="footer"
              class="van-hairline--top van-clearfix gray pad-tb-5"
            >
              <van-row
                type="flex"
                align="center"
                justify="space-between"
                class="p-t-15"
              >
                <van-col
                  span="9"
                  class="text-left"

                >
                  <span v-if="info.priceFromName">{{ info.priceFromName }}提供用车</span>
                  <span v-else>智通天行提供用车</span>
                </van-col>
                <van-col span="12">
                  <span>{{ $t('J009','用车时间') }}：{{ carSearchInfo.useTime ||carSearchInfo.useTimes }}</span>
                </van-col>
              </van-row>
            </div>
          </van-card>
          <!--  -->
          <van-field
            :label="$t('J023','上车地点')"
            v-if="carSearchInfo.useType == 4"
          >
            <span slot="input">
              {{ carSearchInfo.scdd }}
              <div class="font12 gray">
                {{ carSearchInfo.scaddress }}
              </div>
            </span>
          </van-field>
          <div v-else>
            <van-cell :label="carSearchInfo.scaddress">
              <van-row
                type="flex"
                align="center"
              >
                <van-col span="5">
                  <div>{{ $t('J023','上车地点') }}</div>
                </van-col>
                <van-col span="2">
                  <div>
                    <img
                      src="~Assets/images/car/start.png"
                      alt="上车地点"
                      width="20"
                      class="vertical-middle"
                    >
                  </div>
                </van-col>
                <van-col span="17">
                  <div>{{ carSearchInfo.scdd }}</div>
                  <div class="font12 gray">
                    {{ carSearchInfo.scaddress }}
                  </div>
                  <div
                    class="font12 gray"
                    v-show="carSearchInfo.useType==0"
                  >
                    {{ carSearchInfo.desc }}
                  </div>
                </van-col>
              </van-row>
            </van-cell>
            <van-cell>
              <van-row
                type="flex"
                align="center"
              >
                <van-col span="5">
                  <div>{{ $t('J024','下车地点') }}</div>
                </van-col>
                <van-col span="2">
                  <div>
                    <img
                      src="~Assets/images/car/end.png"
                      alt="下车地点"
                      width="21"
                      class="vertical-middle"
                    >
                  </div>
                </van-col>
                <van-col span="17">
                  <div v-if="carSearchInfo.useType==1">
                    {{ carSearchInfo.xcdd }} {{ carSearchInfo.departTerminal }}
                  </div>
                  <div v-else> {{ carSearchInfo.xcdd }} </div>
                  <div class="font12 gray">
                    {{ carSearchInfo.xcaddress }}
                  </div>
                  <!-- <div
                    class="font12 gray"
                    v-show="carSearchInfo.useType==1"
                  >
                    {{ carSearchInfo.desc }}
                  </div>-->
                </van-col>
              </van-row>
            </van-cell>
          </div>

          <van-field
            label="包车天数"
            v-if="carSearchInfo.useType==4"
          >
            <span slot="input">{{ carSearchInfo.useDays }}天</span>
          </van-field>

          <van-row
            type="flex"
            align="center"
            class="bg-white"
            v-if="carSearchInfo.useType==1 && mustFlightNo"
          >
            <van-col
              span="18"
              class="van-hairline--bottom"
            >
              <van-cell
                class="black"
                v-if="carSearchInfo.flightNo"
                @click="toggle('queryFlights')"
              >
                <template #icon>
                  <img
                    src="~Assets/images/car/flightNo.png"
                    alt="."
                    class="vertical-bottom"
                    style="width:26px;height:26px;"
                  >
                </template>
                <template #title>
                  {{ carSearchInfo.departCityName1 }} - {{ carSearchInfo.departAirportName }} {{ carSearchInfo.departTerminal }}
                </template>
                <template #label>
                  {{ carSearchInfo.flightNo }}   {{ formatDate(carSearchInfo.departDate || (carSearchInfo.departTime.length >= 10 ? carSearchInfo.departTime : carSearchInfo.useTime)).monDay }} {{ carSearchInfo.departTime.length >=10 ? formatDate(carSearchInfo.departTime).hm : carSearchInfo.departTime }} 出发
                </template>
              </van-cell>
              <van-field
                v-show="!carSearchInfo.flightNo"
                v-model="carSearchInfo.flightNo"
                @click="toggle('queryFlights')"
                placeholder="请输入航班号"
                readonly
              />
            </van-col>
            <van-col :span="6">
              <span
                class="dBtn main-color"
                @click="myFlight('myFlights')"
              >
                {{ $t('J052','我的航班') }}
              </span>
            </van-col>
          </van-row>

          <!--出行人 -->
          <traver
            :traveler-list="travelerList"
            :title="$t('Car','用车人') "
            cplx="10906"
            :show-card="false"
            store-name="car/travelerList"
            element=".carEdit"
            :radio="false"
            :disabled="carSearchInfo.disabledModify"
            :add-button="!carSearchInfo.disabledModify"
            :person-list="carSearchInfo.Ccsqd.personList"
          />

          <!-- 差旅信息 -->
          <travel-info
            v-if="tripType == 1"
            ref="travelinfo"
            cplx="10906"
            element=".carEdit"
          />

          <!-- 联系信息 -->
          <div>
            <van-field
              :label="$t('D022','联系信息')"
              readonly
              :disabled="carSearchInfo.disabledModify"
              @click="!carSearchInfo.disabledModify && $refs['linker'].toggle()"
              is-link
            >
              <div slot="input">
                {{ linker.linkMan }} ({{ linker.linkTel || linker.linkMobile }})
                <div class="font12 gray">
                  {{ $t('D020','邮箱') }} ({{ linker.linkEmail }})
                </div>
              </div>
            </van-field>
            <!-- 编辑联系人 -->
            <ld-edit-linker
              ref="linker"
              :data="linker"
              @selected="getLinker"
            />
          </div>
          <!--  -->
          <van-notice-bar
            mode="link"
            left-icon="info-o"
            @click="isShow1 = !isShow1"
          >
            乘车须知
          </van-notice-bar>
        </div>
      </mescroll-vue>

      <!-- 底部导航 -->
      <ld-tabbar
        ref="tabbar"
        :price-list="priceList"
        class="bg-white shadow"
      >
        <van-row
          class="full-width"
          type="flex"
          align="center"
        >
          <van-col span="1" />
          <van-col span="15">
            <span class="font12 money-color">&yen;</span>
            <span
              v-if="priceList&&priceList[0]"
              class="font22 money-color"
            >
              {{ priceList[2].price }}
            </span>
            <span class="font10 gray">{{ $t('E017','共') }}{{ travelerList.length }}人</span>
            &nbsp;
            <span
              class="font12 text-left"
              @click="toggle('tabbar')"
            >
              <span>{{ $t('E006','明细') }}</span>
              <van-icon
                name="arrow-up"
                class="vertical-middle"
                size="14"
              />
            </span>
          </van-col>
          <van-col
            span="8"
            class="pad-r-8"
          >
            <ld-button
              :loading="false"
              size="md"
              main
              @click.stop="book"
            >
              {{ $t('F560','提交订单') }}
            </ld-button>
          </van-col>
        </van-row>
      </ld-tabbar>


      <!-- 服务说明 -->
      <van-dialog
        v-model="isShow"
        title="服务说明"
      >
        <div class="pad">
          <div><span class="font-md">预订说明：</span> {{ info.scheduledRulesMsg }}</div>
          <div><span class="font-md">费用说明：</span>{{ info.timeoutRuleMsg }}</div>
          <div><span class="font-md">取消说明：</span>在用车时间之前{{ info.cancelAdvMils }}小时可以免费取消</div>
        </div>
      </van-dialog>

      <!-- 乘车须知 -->
      <van-dialog
        v-model="isShow1"
        title="服务说明"
      >
        <div class="wrapper1">
          <mescroll-vue
            ref="mescroll1"
            :down="{}"
          >
            <div class="pad">
              <p class="text-center blue">
                《免责声明》
              </p>
              <p>
                <span>取消说明：</span><br>
                <span>若为立即用车：司机接单前可免费取消，接单后订单消费用不予退还，订单不支持修改</span>
              </p>
              <p>
                <span>车辆安排：</span><br>
                <span>若无司机接单，系统自动取消订单，订单全额退款，建议您更换供应商或更换时间重新下单，敬请谅解。</span>
              </p>
              <p>
                <span>费用说明：</span> <br>
                <span>1、费用包含：用车费、高速费、停车费、路桥费，无需额外付费给司机。若额外收取此类费用，将双倍赔偿额外收取的费用。</span> <br>
                <span>2、费用不含：</span> <br>
                <span>1）和用车无直接关联的费用，例如景区门票等。</span> <br>
                <span>2）超时等候费。</span>
              </p>
              <p>
                <span>车型说明：</span> <br>
                <span>1、车辆安排遵照同级或升级车辆安排准则，车品牌不可指定。</span> <br>
                <span>2、原则上儿童计入乘车人数，婴儿不计入。实际乘车情况可与司机协商。</span> <br>
                <span>3、各车型的承载人数及行李都有所限制，请您仔细核对，由于您自身选择车型不符而影响您的用车，该损失由您自行承担。</span>
              </p>
              <p>
                <span>路程安排：</span> <br>
                <span>1.一口价服务不接受中途经停、绕路、临时改变路线。</span> <br>
                <span>2.若您选择的地址因交通因素无法送达，比如送达山脉、森林、岛屿、海上、沙漠、无人区等，会视情况送您到就近的地点。</span>
              </p>
            </div>
          </mescroll-vue>
        </div>
      </van-dialog>

      <!-- 行李说明 -->
      <baggage-explain
        :value="info"
        :visibility.sync="baggageExplainShow"
        element=".cardetails"
        height="80%"
      />

      <!--航班列表  -->
      <car-flights
        ref="myFlights"
        :data="myFlightData"
        @selected="getFlisght"
        :use-type="myflt"
      />

      <!-- 查询航班 -->
      <query-flights
        ref="queryFlights"
        @selected="queryFlights"
        @getParams="getFlisght"
      />
    </div>
  </div>
</template>

<script>
import { Card, Field, CellGroup, Cell, NoticeBar,Tag,Dialog } from 'vant'
import MescrollVue from 'mescroll.js/mescroll.vue'

import travelInfo from 'Components/travelInfo'
import ldEditLinker from 'Components/ldEditLinker'
import traver from 'Components/tk/traver'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import ldButton from 'Common/ldButton'
import baggageExplain from '../carOrder/components/BaggageExplain'
import { mapGetters,mapState} from 'vuex'
import { formatDate } from '@/business/utils/dateUtil'
import { metreToKm } from '@/business/utils/string'
import mixin from './mixin'
import { getSysParameter } from 'Utils/publicApi'
import carFlights from './flight/carFlights'
import queryFlights from './flight/queryCarFlights'

export default {
  name: 'CarEdit',
  mixins: [mixin],
  components: {
    MescrollVue,
    travelInfo,
    traver,
    ldTabbar,
    ldButton,
    [Card.name]: Card,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [NoticeBar.name]: NoticeBar,
    [Tag.name]: Tag,
    [Dialog.Component.name]: Dialog.Component,
    ldEditLinker,
    baggageExplain,
    carFlights,
    queryFlights,
  },
  data() {
    return {
      down:{use:false},
      travelInfo: {},
      isShow: false,
      isShow1: false,
      linker:{},
      baggageExplainShow: false,
      mustFlightNo:false,
      myFlightData:[],
      myflt:false
    }
  },
  computed: {
    ...mapGetters({
      carSearchInfo: 'car/carSearchInfo',
      travelerList: 'car/travelerList',
      tripType: 'tripType',
      userInfo:'userInfo',
      sysType:'sysType'
    }),
    ...mapState({
      vipCorp: state => state.app.userInfo.vipCorp,
      carCcsqdNodata: state => state.car.carCcsqdNodata
    }),
    info() {
      //车辆信息
      return this.carSearchInfo.info||{}
    },
    scCity(){
      if(this.carSearchInfo.useType==0||this.carSearchInfo.useType==2){
        return this.carSearchInfo.arriveCityName
      }
      return ''
    },
    xcCity(){
      if(this.carSearchInfo.useType==1||this.carSearchInfo.useType==3){
        return this.carSearchInfo.departCityName
      }
      return ''
    },
    priceList() {
      let rt = [
        { name: '车费', price: this.info.salePrice },
        { name: '服务费', price: this.info.serviceFee },
        { name: '总价', price: this.info.salePrice + this.info.serviceFee, class: 'font-bold' }
      ]
      return rt
    },
  },
  created() {
    let obj = {}
    if(this.vipCorp.bookStyle==2){//出差申请单模式
      //默认显示的人应该是账号自己本人
      let empInfo = this.userInfo.empInfo //账号本人
      if (this.carCcsqdNodata.tkPsgs && this.carCcsqdNodata.tkPsgs.length > 0) { //这个判断是根据出差申请我的航班里面是那个人下单显示跟选人的
        let tkPsgs = this.carCcsqdNodata.tkPsgs
        var tkPsgsdata = tkPsgs.reduce((acc, item) => {//出差航班里面带的人员信息push到tkPsgsdata
          const matches = this.carSearchInfo.Ccsqd.personList.filter((item2) => item.empId === item2.empId);
          return acc.concat(matches);
        }, []);
        //默认显示的人应该是账号自己本人
        let indexi = tkPsgsdata.findIndex((item) => (item.cxrName == empInfo.empName && item.cardNo == empInfo.cardNo))
        let obj
        if (indexi == -1) {
          tkPsgsdata[0].checked = true
          obj = [tkPsgsdata[0]]
          this.$store.commit('car/travelerList', obj)   //显页显示人员
        } else {
          tkPsgsdata[indexi].checked = true
          obj = [tkPsgsdata[indexi]]
          this.$store.commit('car/travelerList', obj)//显页显示人员
        }
        this.carCcsqdNodata.tkPsgsdata = tkPsgsdata   //存入vuex

      } else {//这个就是根据出差申请单显示人员
        let indexi = this.carSearchInfo.Ccsqd.personList.findIndex((item) => (item.cxrName == empInfo.empName && item.cardNo == empInfo.cardNo))
        let obj
        if (indexi != -1) {
          this.carSearchInfo.Ccsqd.personList[indexi].checked = true //将这个人的索引变成true
          obj = [this.carSearchInfo.Ccsqd.personList[indexi]]
          this.$store.commit('car/travelerList', obj)  //存入选中的人员
        } else {
          this.carSearchInfo.Ccsqd.personList[0].checked = true
          let obj = [this.carSearchInfo.Ccsqd.personList[0]]
          this.$store.commit('car/travelerList', obj)
        }
      }
   
    }
    if (this.travelerList.length > 0) {
      obj = {
        linkMan: this.travelerList[0].empName,
        linkTel: this.travelerList[0].phoneNumber,
        linkEmail: this.travelerList[0].email
      }
    } else {
      obj = {
        linkMan: this.userInfo.empInfo.empName,
        linkTel: this.userInfo.empInfo.phoneNumber,
        linkEmail: this.userInfo.empInfo.email
      }
    }
    this.linker = obj
    getSysParameter('11604004').then(res=>{
      this.mustFlightNo=res.value1==1?true:false
    })
    if(this.carSearchInfo.useType == 1 && !this.carSearchInfo.desc.includes('undefined')){
      this.carSearchInfo.useTime = this.carSearchInfo.useTimeName
    }
  },
  mounted(){
    if (this.tripType == 1) {
      this.$refs.travelinfo.getInfo({
        ...this.carSearchInfo.violate,
        violateItem: this.iswb(this.info) ? this.genViolateDesc(this.info) : '',
        violateitem: this.iswb(this.info) ? this.genViolateDesc(this.info) : '',
        ...this.carSearchInfo.Ccsqd
      })
    }
  },
  methods: {
    formatDate,
    getLinker(info) {
      this.linker = {}
      this.linker = info
    },
    async getTravelPolicy () {
      if (!this.travelerList || this.travelerList.length == 0) return

      let reasonCode = this.carSearchInfo.violate.reasonCode,
        reasonDesc = this.carSearchInfo.violate.reasonDesc

      this.$store.commit('car/SET_VIOLATELIST', {
        reasonCode: '',
        reasonDesc: '',
        violateitem: '',
        violateItem: ''
      })

      this.$refs.travelinfo.getInfo(this.carSearchInfo.violate)

      const { data } = await this.$api['carQuery/getTravelPolicy']({
        'empId': this.travelerList[0].empId,
        'useTime': this.carSearchInfo.useTime,
        'sycp': this.getUseTypeBylocaltype(this.carSearchInfo.useType),
        'vehicleTypeId': this.info.vehicleTypeId,
        'price': this.info.salePrice,
        'distance': metreToKm(this.info.distance),
      })

      this.carSearchInfo.info.clzcMatch = data

      if (this.iswb(this.info)) {
        this.$store.commit('car/SET_VIOLATELIST', {
          reasonCode: reasonCode || '',
          reasonDesc: reasonDesc || '',
          violateitem: this.genViolateDesc(this.info),
          violateItem: this.genViolateDesc(this.info),
        })
        this.$refs.travelinfo.getInfo(this.carSearchInfo.violate)
      } else {
        console.log('=不违背=')
      }
    },
    // 下单
    book() {
      if (this.travelerList.length <= 0) {
        this.$toast(this.$t('I001','请选择出行人'))
        return
      }
      if (this.tripType == 1) {
        let bl = this.$refs.travelinfo.result()
        if (bl === false) {
          return false
        } else {
          this.travelInfo = bl
        }
        /**
                 * 是否可以正常预定下单
                 */
        if (!this.canbook(this.info)) return this.$toast('您选择的出行人违背差旅标准，不允许预订，请重新选择。')
        /**
                 * 如果违背了，违背原因和违背说明不能为空
                 */
        if (this.iswb(this.info)) {
          if (!this.travelInfo.reasonCode || !this.travelInfo.reasonDesc) {
            return this.$toast('违背原因不能为空')
          }
        }
      }

      if(this.carSearchInfo.useType==1){//送机
        // 航班号必填
        if(this.mustFlightNo){
          if(!this.carSearchInfo.flightNo){
            this.$toast('请填写航班号！')
            return
          }
        }
      }

      if(this.carSearchInfo.departTime && this.carSearchInfo.departTime.length==5){
        this.carSearchInfo.departTime = formatDate(this.carSearchInfo.useTime).date + ' ' + this.carSearchInfo.departTime
      }

      if(this.carSearchInfo.arriveTime && this.carSearchInfo.arriveTime.length==5){
        this.carSearchInfo.arriveTime = formatDate(this.carSearchInfo.useTime).date + ' ' + this.carSearchInfo.arriveTime
      }

      let arr = [
        {
          pnrNo: this.carSearchInfo.pnrNo, //pnr
          departAirport: this.carSearchInfo.departAirport,
          departAirportName:this.carSearchInfo.departAirportName,
          departTerminal: this.carSearchInfo.departTerminal,
          departTime: this.carSearchInfo.departTime,
          arriveAirport:this.carSearchInfo.arriveAirport,
          arriveAirportName:this.carSearchInfo.arriveAirportName,
          arriveTerminal:this.carSearchInfo.arriveTerminal,
          arriveTime: this.carSearchInfo.useTime,
          flightNo: this.carSearchInfo.flightNo,
          departCity: this.carSearchInfo.departCity, //用车城市id
          arriveCity:this.carSearchInfo.arriveCity,
          fromLat: this.carSearchInfo.sclocation.lat, // 出发纬度
          fromLon: this.carSearchInfo.sclocation.lng,
          toLat: this.carSearchInfo.xclocation.lat, //到达纬度
          toLon: this.carSearchInfo.xclocation.lng,
          toAddressPoi: this.carSearchInfo.xcdd,
          toArea: this.carSearchInfo.toArea,
          toAddress: this.carSearchInfo.xcdd+(this.carSearchInfo.xcaddress?'|'+this.carSearchInfo.xcaddress:''), //: 下车地点
          fromAddressPoi: this.carSearchInfo.scdd,
          fromArea: this.carSearchInfo.fromArea,
          fromAddress: this.carSearchInfo.scdd+(this.carSearchInfo.scaddress?'|'+this.carSearchInfo.scaddress:''), //上车地点
          startTime: this.carSearchInfo.useTime,
          rangeType: '1', // 用车范围1市内/2郊区出城 ,
          useType: '4' //4接机
        },
        {
          pnrNo: this.carSearchInfo.pnrNo, //pnr
          departAirport: this.carSearchInfo.departAirport,
          departAirportName:this.carSearchInfo.departAirportName,
          departTerminal: this.carSearchInfo.departTerminal,
          departTime: this.carSearchInfo.departTime,
          arriveAirport:this.carSearchInfo.arriveAirport,
          arriveAirportName:this.carSearchInfo.arriveAirportName,
          arriveTerminal:this.carSearchInfo.arriveTerminal,
          arriveTime: this.carSearchInfo.arriveTime,
          flightNo: this.carSearchInfo.flightNo,
          arriveCity:this.carSearchInfo.arriveCity,
          departCity: this.carSearchInfo.departCity, //用车城市id
          fromLat: this.carSearchInfo.sclocation.lat,
          fromLon: this.carSearchInfo.sclocation.lng,
          toLat: this.carSearchInfo.xclocation.lat,
          toLon: this.carSearchInfo.xclocation.lng,
          toAddressPoi: this.carSearchInfo.xcdd+(this.carSearchInfo.departTerminal||''),
          toArea: this.carSearchInfo.toArea,
          toAddress: this.carSearchInfo.xcdd+(this.carSearchInfo.xcaddress?'|'+this.carSearchInfo.xcaddress:''), //: 下车地点
          fromAddressPoi: this.carSearchInfo.scdd,
          fromArea: this.carSearchInfo.fromArea,
          fromAddress: this.carSearchInfo.scdd+(this.carSearchInfo.scaddress?'|'+this.carSearchInfo.scaddress:''), //上车地点
          startTime: this.carSearchInfo.useTime,
          rangeType: '1', // 用车范围1市内/2郊区出城 ,
          useType: '5' //送机
        },
        {
          departAirport: this.carSearchInfo.departAirport,
          departCity: this.carSearchInfo.departCity, //用车城市id
          arriveCity:this.carSearchInfo.arriveCity,
          fromLat: this.carSearchInfo.sclocation.lat,
          fromLon: this.carSearchInfo.sclocation.lng,
          toLat: this.carSearchInfo.xclocation.lat,
          toLon: this.carSearchInfo.xclocation.lng,
          toAddress: this.carSearchInfo.xcdd+(this.carSearchInfo.xcaddress?'|'+this.carSearchInfo.xcaddress:''), //: 下车地点
          fromAddress: this.carSearchInfo.scdd+(this.carSearchInfo.scaddress?'|'+this.carSearchInfo.scaddress:''), //上车地点
          fromAddressPoi:this.carSearchInfo.scdd,
          toAddressPoi:this.carSearchInfo.xcdd,
          startTime: this.carSearchInfo.useTime,
          rangeType: '1', // 用车范围1市内/2郊区出城 ,
          useType: '6' //接站
        },
        {
          arriveAirport: this.carSearchInfo.arriveAirport,
          departCity: this.carSearchInfo.departCity, //用车城市id
          arriveCity:this.carSearchInfo.arriveCity,
          fromLat: this.carSearchInfo.sclocation.lat,
          fromLon: this.carSearchInfo.sclocation.lng,
          toLat: this.carSearchInfo.xclocation.lat,
          toLon: this.carSearchInfo.xclocation.lng,
          toAddress: this.carSearchInfo.xcdd+(this.carSearchInfo.xcaddress?'|'+this.carSearchInfo.xcaddress:''), //: 下车地点
          fromAddress: this.carSearchInfo.scdd+(this.carSearchInfo.scaddress?'|'+this.carSearchInfo.scaddress:''), //上车地点
          fromAddressPoi:this.carSearchInfo.scdd,
          toAddressPoi:this.carSearchInfo.xcdd,
          startTime: this.carSearchInfo.useTime,
          rangeType: '1', // 用车范围1市内/2郊区出城 ,
          useType: '7' //送站
        },
        {
          departCity: this.carSearchInfo.departCity, //用车城市id
          fromLat: this.carSearchInfo.sclocation.lat,
          fromLon: this.carSearchInfo.sclocation.lng,
          fromAddress: this.carSearchInfo.scaddress, //上车地点
          fromAddressPoi:this.carSearchInfo.scdd,
          rangeType: this.carSearchInfo.useRange?'2':'1', // 用车范围1市内/2郊区出城 ,
          startTime: this.carSearchInfo.useTime,
          useDays: this.carSearchInfo.useDays, //用车天数
          orderType: '1',
          endTime: '', //用车时间止
          useType: this.carSearchInfo.useDays === 0.5 ? '2' : '1' // 2半日包 1日包
        }
      ]
      let obj = {
        cacheId:this.carSearchInfo.cacheId,
        routeId: '',
        ccsqdId: this.travelInfo.ccsqdId,
        ccsqdNo: this.travelInfo.ccsqdNo,
        ccsqdRemark: this.travelInfo.ccsqdRemark,
        costCenterCode: this.travelInfo.costCenterCode,
        costCenterId: this.travelInfo.costCenterId,
        costCenterName: this.travelInfo.costCenterName,
        projectCode: this.travelInfo.projectCode,
        projectId: this.travelInfo.projectId,
        projectName: this.travelInfo.projectName,
        subjectCode: this.travelInfo.subjectCode, //科目码
        reasonCode: this.travelInfo.reasonCode || '', // 违背原因代码
        reasonDesc: this.travelInfo.reasonDesc || '', // 违背原因说明
        tripType: this.tripType, // 因公因私,1是因公,2是因私
        violateitem: this.travelInfo.violateitem || '', // 违背事项说明
        violateitemCode: this.travelInfo.reasonCode || '11109' || '', // 违背事项代码
        linkEmail: this.linker.linkEmail,
        linkman: this.linker.linkMan,
        linkTel: this.linker.linkTel,
        empId: this.travelerList
          .map(item => {
            return item.empId
          })
          .join(','),
        empName: this.travelerList
          .map(item => {
            return this.$options.filters.getName(item)
          })
          .join(','),
        fsEmpId: '',
        ifSameOrder: '', //订单是否一致 DY DN ,
        orderFrom: this.sysType,
        phoneNumber: this.travelerList
          .map(item => {
            return item.phoneNumber
          })
          .join(','), //出行人手机
        priceFrom: this.info.priceFrom, //价格来源
        priceFromName: this.info.priceFromName, //价格来源名称
        priceId: this.info.priceMark, //价格id
        //sfbrdc: 0, //是否帮人订车前端传入
        unionOrderId: '', //关联订单id
        unionOrderType: '', //关联订单单据类型 109
        productId: this.info.productId, //用车产品id ,
        ext1: this.carSearchInfo.extraInfo
      }
      if(!obj.linkTel || !obj.linkman){
        this.$toast('请填写联系人信息')
        return
      }
      this.$api['carQuery/bookYyyc'](
        Object.assign({}, arr[this.carSearchInfo.useType], obj)
      ).then(res => {
        let cache=res.data||{}
        if (cache.orderId) {
          this.jump(cache.orderId,'单')//单人的正常处理
        }
        if(cache.orderIds){
          this.jump(cache.orderIds,'多')//多人
        }
      })

    },
    jump(cache,naem) {
      if(naem=='多'){
        this.$dialog.alert({
          title: this.$t('C474', '提示'),
          message: '下单完成，系统生成两个订单前往订单列表查看'
        }).then(() => {
          this.$router.push({
            path: '/allOrder',
            query: { findType: 1, productType: '10901' }
          })
        })
        return
      }
  
      this.carSearchInfo.priceList=this.priceList
      this.$router.push({
        path: '/car/carCmp',
        query: { 
          orderId: cache,
        }
      })
    },
    dateTime(type){
      if(type==0){
        let cache=this.carSearchInfo.useTime.split(' ')[0]
        if(this.carSearchInfo.travelDay){
          cache=formatDate(cache,this.carSearchInfo.travelDay).date
        }
        return cache+' '+this.carSearchInfo.arriveTime
      }
    },
    queryFlights(param,date) {
      this.myflt=false
      this.myFlightData = param
      this.carSearchInfo.departDate=date
      this.carSearchInfo.arriveDate=date
      this.toggle('myFlights',{data:param,date:date})
    },
    myFlight(name) {
      this.myflt=true
      //获取系统内机票订单
      //业务类型 1接送 2送机 不能为空
      this.$api['common/queryWcxOrder']({ ywlx: 1 }).then(res => {
        let cache = res.data || []
        cache.reverse()
        if (cache.length > 0) {
          this.myFlightData = cache
          this.toggle(name)
        } else {
          this.$toast('未查询到您的航班信息')
        }
      })
    },
    getFlisght(flight,asd){
      console.log(asd)
      this.carSearchInfo.departAirport=flight.departAirport
      this.carSearchInfo.departAirportName=flight.departAirportName
      this.carSearchInfo.departTerminal=flight.departTerminal
      this.carSearchInfo.arriveAirport=flight.arriveAirport
      this.carSearchInfo.arriveAirportName=flight.arriveAirportName
      this.carSearchInfo.arriveTerminal=flight.arriveTerminal
      this.carSearchInfo.departCityName1=flight.departCityName

      if(flight.departDate){
        this.carSearchInfo.departDate=flight.departDate
      }
      if(flight.arriveDate){
        this.carSearchInfo.arriveDate=flight.arriveDate
      }
      if(flight.departTime.length==5){
        this.carSearchInfo.departTime= this.carSearchInfo.departDate +' '+flight.departTime
        this.carSearchInfo.arriveTime= this.carSearchInfo.arriveDate +' '+flight.arriveTime
      }else if(flight.departTimes){
        this.carSearchInfo.departTime=flight.departTimes
        this.carSearchInfo.arriveTime=flight.arriveTimes
      }else{
        this.carSearchInfo.departTime=flight.departTime
        this.carSearchInfo.arriveTime=flight.arriveTime
      }
      this.carSearchInfo.flightNo=flight.flightNo
      this.$forceUpdate()
    },
    toggle(ref) {
      this.$refs[ref].toggle()
    }
  },
  watch: {
    travelerList: function () {
      this.getTravelPolicy()
    }
  }
}
</script>

<style lang="less" scoped>
.carEdit {

  .van-card {
    background-color: @color-background-white;
  }
  .van-card__content {
    min-height: auto;
  }
  .van-card__thumb {
    height: auto;
  }
  .sc {
    padding: 8px 16px;
  }
  .carEditwrapper {
    height: calc(100vh - 96px);
    overflow: hidden;
  }
    .pad-r-8{
        padding-right: 8px;
    }
    .box {
        padding: 0.1rem;
        width: 100%;
        height: 100%;
        position: relative;
        overflow-y: scroll;
        > div {
            margin-bottom: 0.1rem;
        }
        .plane {
            height: 1.2rem;
        }
        .rules {
            position: relative;
            font-size: @font-size-24;
            padding-left: 15px;
            height: 0.62rem;
            line-height: 0.62rem;
        }
        .fee {
            background-color: @color-background-white;
            height: 1rem;
            line-height: 1rem;
            font-size: @font-size-24;
            padding-left: 15px;
        }
        .cell {
            font-size: @font-size-30;
        }
    }
    .planeBox {
            height: 2.7rem;
            background-color: transparent;
        > div {
            margin-bottom: 0.2rem;
        }
    }
    .type {
        padding: 1px 4px;
        margin-left: 4px;
    }
  .info {
    font-size: 16px;
    vertical-align: text-bottom;
  }
  .pad {
    padding: 16px;
    font-size: 12px;
    div,
    p {
      padding-bottom: 4px;
    }
  }
  .wrapper1 {
    height: 50vh;
    overflow: hidden;
  }
    .pad-tb-5{
      padding: 5px 0;
  }
          .dBtn {
            display: inline-block;
            width: 1.35rem;
            height: 0.48rem;
            line-height: 0.46rem;
            text-align: center;
            border-radius: 24px;
            border: 1px solid;
            font-size: @font-size-12;
        }
}
</style>
